import { TrendingItem, Product, Suggestion } from "../../domain/models/SearchSuggestion";

/**
 * Application ViewModels - Granular, reusable pieces
 * These are domain-based and can be combined in different ways by presentation layer
 */

export interface TrendingItemVm {
  name: string;
  url: string;
}

export interface SuggestionVm {
  title: string;
}

export interface ProductVm {
  image: string;
  name: string;
  url: string;
  designId?: string;
}

export interface TrendingVm {
  list: TrendingItemVm[];
  trendingTitle: string;
}

export interface ProductsVm {
  productTitle: string;
  list: ProductVm[];
}

/**
 * Conversion functions: Domain -> Application ViewModel
 */
export function toTrendingItemVM(item: TrendingItem): TrendingItemVm {
  return {
    name: item.name,
    url: item.url,
  };
}

export function toSuggestionVM(item: Suggestion): SuggestionVm {
  return {
    title: item.title,
  };
}

export function toProductVM(item: Product): ProductVm {
  return {
    image: item.image,
    name: item.name,
    url: item.url,
    ...(item.designId ? { designId: item.designId } : {}),
  };
}

export function toTrendingVM(trending: { list: TrendingItem[]; trendingTitle: string }): TrendingVm {
  return {
    list: trending.list.map(item => toTrendingItemVM(item)),
    trendingTitle: trending.trendingTitle,
  };
}

export function toProductsVM(products: { productTitle: string; list: Product[] }): ProductsVm {
  return {
    productTitle: products.productTitle,
    list: products.list.map(item => toProductVM(item)),
  };
}

